module.exports = __webpack_public_path__ + "img/img-0d290d.jpg";